import React from 'react';
import {
  HiOutlineCheckCircle,
  HiOutlineInformationCircle,
  HiOutlineExclamationTriangle,
  HiOutlineXMark,
} from 'react-icons/hi2';

// Per-type styling: container tint, border, and icon. Kept in one place so a
// new type is a single entry.
const TYPE_STYLES = {
  success: {
    Icon: HiOutlineCheckCircle,
    container: 'bg-emerald-50/80 dark:bg-emerald-900/10 border-emerald-200/60 dark:border-emerald-700/20',
    icon: 'text-emerald-500 dark:text-emerald-400',
  },
  info: {
    Icon: HiOutlineInformationCircle,
    container: 'bg-blue-50/80 dark:bg-blue-900/10 border-blue-200/60 dark:border-blue-700/20',
    icon: 'text-blue-500 dark:text-blue-400',
  },
  warning: {
    Icon: HiOutlineExclamationTriangle,
    container: 'bg-amber-50/80 dark:bg-amber-900/10 border-amber-200/60 dark:border-amber-700/20',
    icon: 'text-amber-500 dark:text-amber-400',
  },
};

const AnnouncementBanner = ({ announcement, onDismiss }) => {
  const style = TYPE_STYLES[announcement.type] || TYPE_STYLES.info;
  const { Icon } = style;
  const dismissible = announcement.dismissible !== false;

  return (
    <div className={`flex items-center gap-3 px-4 py-2.5 rounded-xl border ${style.container}`}>
      <Icon className={`flex-shrink-0 w-5 h-5 ${style.icon}`} />

      <p className="flex-1 text-sm text-gray-600 dark:text-gray-400">
        {announcement.message}
      </p>

      {dismissible && (
        <button
          onClick={() => onDismiss(announcement.id)}
          aria-label="Dismiss"
          className="flex-shrink-0 p-0.5 text-gray-400 dark:text-gray-600 hover:text-gray-600 dark:hover:text-gray-400 transition-colors"
        >
          <HiOutlineXMark className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

export default AnnouncementBanner;
